import BaseService from "./base.service";
import { CONFIG } from "@/config";

class SwService extends BaseService {
  async cacheResources(resources) {
    const appCache = CONFIG.CACHEV;

    try {
      // console.log(`start Cache: ${appCache} @ ${Math.floor(Date.now() / 1000)}`);

      try {
        const cache = await caches.open(appCache);

        await cache.addAll(resources);

        // console.log(`Cached: ${appCache} @ ${Math.floor(Date.now() / 1000)}`);
      } catch (error) {
        console.error(`Error caching resources: ${error.message}`);
        throw error;
      }

      // console.log(`Cache Complete @ ${Math.floor(Date.now() / 1000)}`);
      return true;
    } catch (error) {
      if (error.name === "QuotaExceededError") {
        return error.name;
      } else {
        return false;
      }
    }
  }
}

export default new SwService();
